import { render } from "./HeroiconsOutlineChartSquareBar.vue?vue&type=template&id=07dd98ef"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChartSquareBar.vue"]])

export default __exports__